import videojs from 'video.js';

export class OutroPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    return presentationData.playerOptions.outro.enabled && !playCoverData.hasQuizzes;
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('outro')) {
            const { IntroPlugin } = await import(/* webpackChunkName: 'outro' */ './intro-outro.js');
            player.registerPlugin('outro', IntroPlugin);

            player.outro().enabled = true;
        }
    }
}